// extracted by mini-css-extract-plugin
module.exports = {"navlink":"NavContainer_navlink__VTk48","overflow":"NavContainer_overflow__pU5ME","navlinkMotion":"NavContainer_navlinkMotion__vcrNL"};